/* eslint-disable no-console */
import { LaunchParams } from '@/features/game-context/types';
import {
  DdEventCategory,
  DdEventType,
  Logger,
} from '@/features/logging/logger';

export const logFanduelInfo = (message: string) =>
  console.log(`%c${message}`, 'color:rgb(0, 123, 255)');

export const logWBLaunchV2Info = (message: string) =>
  console.log(`%c FD-WBLv2 -> ${message}`, 'color:rgb(255, 140, 0)');

export enum NotifySuccessActionsNames {
  INIT_STARTED = 'FD-INIT: CLIENT ready to receive events',
  INIT_SUCESSFULL = 'FD-INIT: Game params received and context initialized',
  AWAGER_DEPOSIT_CLICKED = 'PROVIDER-EVENT: Awager add funds in game clicked',
}

export const ddNotifyClientInitialization = () => {
  logFanduelInfo(NotifySuccessActionsNames.INIT_STARTED);

  Logger.rumAction({
    name: NotifySuccessActionsNames.INIT_STARTED,
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
  });
};

export const ddNotifyContextIntializedAction = (payload: LaunchParams) => {
  logFanduelInfo(NotifySuccessActionsNames.INIT_SUCESSFULL);

  Logger.rumAction({
    name: NotifySuccessActionsNames.INIT_SUCESSFULL,
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
    context: {
      ...payload,
    },
  });
};

export const ddNotifyAwagerFundsClicked = (payload: LaunchParams) => {
  Logger.rumAction({
    name: NotifySuccessActionsNames.AWAGER_DEPOSIT_CLICKED,
    useCase: DdEventCategory.ProviderIntegration,
    eventType: DdEventType.Success,
    context: {
      ...payload,
    },
  });
};
